import { type RoomState } from '../models/RoomState'
import { type SlideDeckRole } from '../models/SlideDeckRole'

export const doUsersSatisfyRoleRequirements = ({
  users,
  roleAssignment,
  roles,
}: {
  users: Array<string>
  roleAssignment: RoomState['data']['assignmentRoles']
  roles: SlideDeckRole[]
}): boolean => {
  const roleIdToRequirements: Map<
    string,
    { min: number; max: number; userCount: number }
  > = new Map()
  // iterate over roles to build a map of roleId to its min, max and current user count
  roles.forEach((role) => {
    roleIdToRequirements.set(role.id, {
      min: role.data.roleMin,
      max: role.data.roleMax,
      userCount: 0,
    })
  })

  // iterate over users to count how many users are assigned to each role
  users.forEach((userId) => {
    const roleId = roleAssignment?.[userId]
    if (roleId) {
      const roleReq = roleIdToRequirements.get(roleId)
      if (roleReq) {
        roleReq.userCount += 1
      }
    }
  })

  // check if each role satisfies its min and max requirements
  for (const [, { min, max, userCount }] of roleIdToRequirements) {
    if (userCount < min || userCount > max) {
      return false
    }
  }

  return true
}
